<template>
    <div class="assessmentCenter">
        <Header  pageTitle="评价中心" />
        <div class="content">
            <div class="van_tabs">
                <van-tabs
                    title-active-color="#3A82F8"
                    color="#3A82F8"
                    v-model="type"
                    @change="tabChange"
                >
                    <van-tab title="待评价" name="0"></van-tab>
                    <van-tab title="已评价/追评" name="1"></van-tab>
                </van-tabs>
            </div>

        </div>
    </div>
</template>
<script>
import Header from "@/views/mobileView/components/header/index.vue";
export default {
    data(){
        return {
            type:'0'
        }
    },
    components: {
        Header
    },
    methods:{
        tabChange(){

        }
    }
}
</script>
<style lang="scss">
html,
body {
  height: 100%;
  background: #f5f5f5;
}
.assessmentCenter{
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: calc(constant(safe-area-inset-top) + 44px) !important;
    padding-top: calc(env(safe-area-inset-top) + 44px) !important;
    .content{
        .van_tabs{
            margin-bottom: 12px;
        }
    }

}
</style>